import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";

var _auth;

/****请求接口的链接****/
//用户相关接口
export var user = {
  login: '/index.php/admin/admin/login',
  //登录接口
  logout: '/index.php/admin/admin/logout',
  //退出登录
  UpdStatus: '/api/authcenter/Account/UpdStatus',
  // 修改账号状态
  getUserInfo: '/index.php/admin/admin/get_info',
  // new 获取当前用户信息
  getregion: '/index.php/api/firmwareversion/getregion',
  //获取地区省市县
  login_success_permission: '/index.php/api/admin/login_success_permission',
  // 81.登录成功获取当前用户菜单
  releaseLocking: '/api/authcenter/Account/CheckPwd',
  // 解除锁屏
  ResetPWD: '/api/authcenter/Account/ResetPWD',
  // 重置密码
  UpdPWD: '/api/authcenter/Account/UpdPWD',
  //修改密码
  GetCallStyle: '/api/hrm/Person/GetCallStyle',
  //根据token获取呼叫方式
  GetRoleList: '/api/authcenter/Role/GetRoleListByAccount',
  //根据Token获取当前用户的角色信息
  AccountGetListByName: "/api/authcenter/Account/GetListByName",
  //根据姓名获取账号信息
  DelAccountRole: '/api/authcenter/Role/DelAccountRole',
  //删除 角色 信息
  UpdPWDWage: '/api/authcenter/Account/SetPayrollPwd',
  //修改查看工资密码
  SetMotto: '/api/hrm/Person/SetMotto',
  //设置登录人座右铭
  SetAvatar: '/api/hrm/Person/SetAvatar',
  //设置头像
  register: '/index.php/api/admin/register',
  //new 注册商家账号
  getsms: '/index.php/admin/admin/getsms',
  //new 获取短信验证码
  GetEmall: '/index.php/admin/admin/getemailcode',
  //获取邮箱验证码
  Forgot: '/index.php/admin/admin/findpassword',
  //找回密码
  savebaseinfo: '/index.php/api/admin/savebaseinfo',
  //new 保存基本信息
  changeaccount: '/index.php/api/admin/changeaccount',
  //new 变更账号
  real_name_auth: '/index.php/api/admin/real_name_auth',
  //new 19.实名认证提交
  enterprise: '/index.php/api/admin/enterprise',
  //new 20.企业认证
  enterprise_audit_count_down: '/index.php/api/admin/enterprise_audit_count_down',
  //企业认证倒计时
  realname_audit_count_downr: '/index.php/api/admin/realname_audit_count_down' //实名认证倒计时

}; //共用的接口

export var common = {
  UploadFile: '/index.php/api/productcreate/upload',
  // 上传图片文件
  uploadfiles: '/index.php/api/productcreate/uploadfile',
  //上传其他文件
  getAllEnumType: '/api/commondata/Enum/GetAllEnumType',
  QueryCustomerAptitudeLevel: '/api/crm/Customer/QueryCustomerAptitudeLevel',
  // 获取客户资质标签数据
  GetImportDepartment: '/api/crm/CustomerPool/GetImportDepartment',
  // 获取可导入客户部门列表
  GetCustomerSourceList: '/api/crm/CustomerPool/GetCustomerSourceList',
  // 客户来源
  GetFile: '/api/cloudDisk/ServiceFile/GetFile',
  // 根据文件标识获取文件信息
  GetDeptTree: '/api/hrm/Dept/GetTree',
  // 获得组织树
  GetChildDeptAndAllPerson: '/api/hrm/Dept/GetChildDeptAndAllPerson',
  //根据部门Id 获取部门的下一级部门列表和部门及下属所有部门的人员信息

  /** 反馈开始*/
  AddFeedback: '/api/oa/Feedback/AddFeedback',
  //添加反馈
  ReplyFeedback: '/api/oa/Feedback/ReplyFeedback',
  //回复反馈
  QueryFeedback: '/api/oa/Feedback/QueryFeedback' //查询反馈列表

  /** 反馈结束*/

};
export var home = {
  index_overview: '/index.php/api/statisticsindex/index_overview',
  product_overview: '/index.php/api/statisticsindex/product_overview',
  //产品
  user_overview: '/index.php/api/statisticsindex/user_overview',
  //用户
  service_overview: '/index.php/api/statisticsindex/service_overview' //服务

};
export var xinli = {
  company_add: '/index.php/admin/companymanage/company_add',
  //新增机构
  upload_pic: '/index.php/admin/companymanage/upload_pic',
  //上传图片
  company_list: '/index.php/admin/companymanage/company_list',
  //机构列表
  company_update: '/index.php/admin/companymanage/company_update',
  //编辑机构
  company_del: '/index.php/admin/companymanage/company_del',
  //删除机构
  company_desc_save: '/index.php/admin/companymanage/company_desc_save',
  //保存机构介绍
  companypass_add: '/index.php/admin/companypass/companypass_add',
  //新增机构密码
  companypass_list: '/index.php/admin/companypass/companypass_list',
  //新增机构密码
  companypass_update: '/index.php/admin/companypass/companypass_update',
  //编辑机构密码
  companypass_del: '/index.php/admin/companypass/companypass_del',
  //删除机构编码
  companypass_file_upload: '/index.php/admin/companypass/companypass_file_upload',
  //导入机构密码文件
  expert_add: '/index.php/admin/expert/expert_add',
  //新增咨询师
  expert_list: '/index.php/admin/expert/expert_list',
  //获取咨询师列表
  expert_update: '/index.php/admin/expert/expert_update',
  //编辑咨询师
  expert_del: '/index.php/admin/expert/expert_del',
  //删除咨询师
  special_add: '/index.php/admin/special/special_add',
  //新增专题
  special_list: '/index.php/admin/special/special_list',
  //专题列表
  special_update: '/index.php/admin/special/special_update',
  //编辑专题
  special_del: '/index.php/admin/special/special_del',
  //删除专题
  get_testcat_password: '/index.php/admin/exam/get_testcat_password',
  //获取密码列表和专题列表
  exam_import: '/index.php/admin/exam/exam_import',
  //获取密码列表和专题列表
  exam_list: '/index.php/admin/exam/exam_list',
  //获取题库列表
  exam_del: '/index.php/admin/exam/exam_del',
  //删除题库
  exam_download: '/index.php/admin/exam/exam_download',
  //下载题库
  testlog_list: '/index.php/admin/testlog/testlog_list',
  //评测记录列表
  testlog_detail: '/index.php/admin/testlog/testlog_detail',
  //评测记录列表
  testlog_export: '/index.php/admin/testlog/testlog_export',
  //导出试卷
  testlog_download: '/index.php/admin/testlog/testlog_download',
  //下载试卷
  tongji_expert: '/index.php/admin/tongji/tongji_expert',
  //咨询师分析
  tongji_special: '/index.php/admin/tongji/tongji_special',
  //咨询师分析
  tongji_user: '/index.php/admin/tongji/tongji_user',
  //用户分析
  data_detail_export: '/index.php/admin/tongji/data_detail_export',
  //导出数据详情
  appoint_list: '/index.php/admin/appoint/appoint_list',
  //预约记录
  publicspecial_list: '/index.php/admin/publicspecial/publicspecial_list',
  //公开课列表
  publicspecial_add: '/index.php/admin/publicspecial/publicspecial_add',
  //新增公开课
  publicspecial_handle: '/index.php/admin/publicspecial/publicspecial_handle',
  //启用禁用
  publicspecial_update: '/index.php/admin/publicspecial/publicspecial_update',
  //编辑公开课
  publicspecial_del: '/index.php/admin/publicspecial/publicspecial_del',
  //删除公开课
  appoint_export: '/index.php/admin/appoint/create_xls_export',
  //导出预约记录
  appoint_review: '/index.php/admin/appoint/appoint_review',
  //审核预约记录
  testcat_add: '/index.php/admin/testcat/testcat_add',
  //新增分类
  testcat_list: '/index.php/admin/testcat/testcat_list',
  //新增分类
  testcat_update: '/index.php/admin/testcat/testcat_update',
  //新增分类
  testcat_del: '/index.php/admin/testcat/testcat_del' //新增分类

};
export var auth = (_auth = {
  addmodule: "/index.php/admin/permissions/addmodule",
  //新增模块
  modulelist: "/index.php/admin/permissions/modulelist",
  //获取模块列表
  moduledel: "/index.php/admin/permissions/moduledel",
  //删除模块
  module_update: "/index.php/admin/permissions/module_update",
  //编辑模块
  getmodule: "/index.php/admin/permissions/getmodule",
  //编辑模块
  addresource: "/index.php/admin/permissions/addresource",
  //新增接口
  resourcelist: "/index.php/admin/permissions/resourcelist",
  //获取接口列表
  resourcedel: "/index.php/admin/permissions/resourcedel",
  //删除接口
  resource_update: "/index.php/admin/permissions/resource_update",
  //编辑接口
  getmodule_api: "/index.php/admin/permissions/getmodule_api",
  //根据模块名称获取接口列表
  addmenu: "/index.php/admin/permissions/addmenu",
  //新增菜单或页面
  getmenulist: "/index.php/admin/permissions/getmenulist",
  //获取菜单列表
  menu_del: "/index.php/admin/permissions/menu_del",
  //获取菜单列表
  menu_update: "/index.php/admin/permissions/menu_update",
  //编辑菜单
  api_config_data: "/index.php/admin/permissions/api_config_data",
  //菜单列表接口配置时获取基本数据
  api_config_update: "/index.php/admin/permissions/api_config_update",
  //菜单接口配置时执行保存操作
  addgroup: "/index.php/admin/permissions/addgroup",
  //新增角色
  grouplist: "/index.php/admin/permissions/grouplist",
  //新增角色
  delgroup: "/index.php/admin/permissions/delgroup",
  //新增角色
  group_update: "/index.php/admin/permissions/group_update",
  //编辑角色
  getgroup_permission: "/index.php/admin/permissions/getgroup_permission"
}, _defineProperty(_auth, "getgroup_permission", "/index.php/admin/permissions/getgroup_permission"), _defineProperty(_auth, "groupPermission_config", "/index.php/admin/permissions/groupPermission_config"), _defineProperty(_auth, "getgrouplist", "/index.php/admin/permissions/getgrouplist"), _defineProperty(_auth, "adduser", "/index.php/admin/account/adduser"), _defineProperty(_auth, "change_adminstatus", "/index.php/admin/account/change_adminstatus"), _defineProperty(_auth, "admin_update", "/index.php/admin/account/admin_update"), _defineProperty(_auth, "admin_del", "/index.php/admin/account/admin_del"), _defineProperty(_auth, "getadminlist", "/index.php/admin/account/getadminlist"), _defineProperty(_auth, "getmenu_permission", "/index.php/admin/account/getmenu_permission"), _defineProperty(_auth, "Permission_config", "/index.php/admin/account/Permission_config"), _defineProperty(_auth, "login_success_permission", "/index.php/admin/admin/login_success_permission"), _defineProperty(_auth, "getmygroup", "/index.php/admin/account/getmygroup"), _defineProperty(_auth, "default_role", "/index.php/admin/permissions/set_group_default"), _auth);
export var pests = {
  'project_list': '/index.php/api/project/project_list',
  //项目列表
  'project_add': '/index.php/api/project/project_add',
  //新增项目
  'project_update': '/index.php/api/project/project_update',
  //编辑项目
  'project_del': '/index.php/api/project/project_del',
  //删除项目
  maintain_list: '/index.php/api/maintain/maintain_list',
  //获取人员列表
  maintain_add: '/index.php/api/maintain/maintain_add',
  //获取人员列表
  maintain_update: '/index.php/api/maintain/maintain_update',
  //获取人员列表
  maintain_del: '/index.php/api/maintain/maintain_del',
  //删除人员
  upload_file: '/index.php/api/common/upload_file',
  //上传文件
  building_add: '/index.php/api/building/building_add',
  //新增建筑物
  building_list: '/index.php/api/building/building_list',
  //建筑物列表
  building_update: '/index.php/api/building/building_update',
  //编辑建筑物
  building_del: '/index.php/api/building/building_del',
  //删除建筑物
  floor_add: '/index.php/api/floor/floor_add',
  //新增楼层
  floor_list: '/index.php/api/floor/floor_list',
  //楼层列表
  floor_update: '/index.php/api/floor/floor_update',
  //编辑楼层
  floor_del: '/index.php/api/floor/floor_del',
  //删除楼层
  prevent_cat_add: '/index.php/api/prevent/prevent_cat_add',
  //新增防制分类
  prevent_cate_list: '/index.php/api/prevent/prevent_cate_list',
  //防制分类列表
  prevent_cate_update: '/index.php/api/prevent/prevent_cate_update',
  //编辑防制分类
  prevent_cate_del: '/index.php/api/prevent/prevent_cate_del',
  //删除防制分类
  device_add: '/index.php/api/device/device_add',
  //新增设备
  device_list: '/index.php/api/device/device_list',
  //设备列表
  device_update: '/index.php/api/device/device_update',
  //编辑设备
  device_del: '/index.php/api/device/device_del',
  //删除设备
  alarm_about: '/index.php/api/alarm/alarm_about',
  //获取告警相关下
  alarm_list: '/index.php/api/alarm/alarm_list',
  //获取告警列表
  handle_alarm: '/index.php/api/alarm/handle_alarm',
  //处理告警
  alarm_del: '/index.php/api/alarm/alarm_del',
  //删除告警
  maintenance_list: '/index.php/api/maintenance/maintenance_list',
  //维保管理列表
  maintenance_audit: '/index.php/api/maintenance/maintenance_audit',
  //审核维保记录
  maintenance_download: '/index.php/api/maintenance/maintenance_download',
  //下载维保报告
  maintenance_report: '/index.php/api/maintenance/maintenance_report',
  //查看维保报告
  device_event_history: '/index.php/api/device/device_event_history',
  //事件记录
  get_device_info: '/index.php/api/index/get_device_info',
  //左上角设备统计
  get_alarm_info: '/index.php/api/index/get_alarm_info',
  //中边中部报警统计
  device_year_increase: '/index.php/api/index/device_year_increase',
  //获取左下角近一年新增设备
  indexProject_list: '/index.php/api/index/project_list',
  //右侧底部项目列表（中部经纬度）统计
  getdownloadtoken: '/index.php/api/maintenance/getdownloadtoken',
  //获取下载token
  updatepwd: '/index.php/admin/admin/updatepwd',
  //当前用户修改密码
  device_onoffline_history: '/index.php/api/device/device_onoffline_history',
  maintenance_download_zip: '/index.php/api/maintenance/maintenance_download_zip',
  //打包下载维保报告
  building_trend: '/index.php/api/device/building_trend',
  //防制趋势图
  get_firmware_info: '/index.php/api/device/get_firmware_info',
  //获取固件信息
  upup_firmware: '/index.php/api/device/upup_firmware',
  //升级固件
  device_file_upload: '/index.php/api/device/device_file_upload',
  //上传设备xls文件
  device_file_import: '/index.php/api/device/device_file_import',
  //导入设备
  device_file_list: '/index.php/api/device/device_file_list',
  //导入的文件列表
  device_file_fail_list: '/index.php/api/device/device_file_fail_list',
  //查看失败的行
  set_device_wifi: '/index.php/api/device/set_device_wifi',
  //wifi设置
  device_cmd_config: '/index.php/api/device/device_cmd_config',
  //控制设置
  get_device_cmd_config: '/index.php/api/device/get_device_cmd_config',
  //获取控制设置内容
  midu_analysis: '/index.php/api/device/midu_analysis',
  //蝇害密度分析
  real_time_view: '/index.php/api/device/real_time_view',
  //实时查看
  refresh_device_pic_ajax: '/index.php/api/device/refresh_device_pic_ajax',
  //5秒后拉取图片到本地
  company_list: '/index.php/api/project/company_list' //项目管理 获取公司列表

};
export var jingxiaoshang = {
  'device_distribution_list': '/index.php/admin/device/device_distribution_list',
  //设备分销管理列表接口
  'area_list': '/index.php/admin/area/area_list',
  //区域列表
  'get_merchant_all': '/index.php/admin/device/get_merchant_all',
  //经销商列表
  'allocation_add': '/index.php/admin/device/allocation_add',
  //分配经销商
  'allocation_log': '/index.php/admin/device/allocation_log',
  //分配详情
  'allocation_del': '/index.php/admin/device/allocation_del',
  //删除
  'getdownloadtoken': '/index.php/admin/device/getdownloadtoken',
  //获取下载token
  'downloadFile': '/index.php/admin/device/downloadFile',
  //下载
  'devicedetail_list': '/index.php/admin/devicedetail/devicedetail_list',
  //设备详细信息列表
  'handle_fx_status': '/index.php/admin/devicedetail/handle_fx_status',
  //启用禁用
  'appeal': '/index.php/admin/devicedetail/appeal',
  //申诉
  'did_del': '/index.php/admin/devicedetail/did_del',
  //删除
  'area_add': '/index.php/admin/area/area_add',
  //新增区域
  'area_update': '/index.php/admin/area/area_update',
  //编辑区域
  'area_del': '/index.php/admin/area/area_del',
  //删除
  'merchant_add': '/index.php/admin/merchant/merchant_add',
  //新增经销商
  'merchant_update': '/index.php/admin/merchant/merchant_update',
  //编辑经销商
  'merchant_list': '/index.php/admin/merchant/merchant_list',
  //经销商列表
  'merchant_del': '/index.php/admin/merchant/merchant_del',
  //删除经销商
  'transfer_merchant_parent': '/index.php/admin/merchant/transfer_merchant_parent',
  //转移
  'device_increate_activation': '/index.php/admin/datatongji/device_increate_activation',
  //设备新增激活统计
  'device_accumulate_online': '/index.php/admin/datatongji/device_accumulate_online',
  //设备新增激活统计
  'handle_state': '/index.php/admin/merchant/handle_state',
  //操作状态
  'alarm_list': '/index.php/admin/alarm/alarm_list',
  //告警列表
  'handle_alarm': '/index.php/admin/alarm/handle_alarm',
  //处理告警
  'iotuser_list': '/index.php/admin/iotuser/iotuser_list',
  //物联网用户列表
  'view_device': '/index.php/admin/iotuser/view_device',
  //查看设备
  'get_type': '/index.php/admin/dict/get_type',
  //获取分类
  'dict_add': '/index.php/admin/dict/dict_add',
  //新增字典
  'dict_del': '/index.php/admin/dict/dict_del',
  //删除字典
  'dict_list': '/index.php/admin/dict/dict_list',
  //字典列表
  'set_default': '/index.php/admin/dict/set_default',
  //设置默认
  'dict_update': '/index.php/admin/dict/dict_update',
  //编辑字典
  'history_log': '/index.php/admin/device/history_log',
  //历史记录
  'history_log_del': '/index.php/admin/device/history_log_del',
  //删除历史记录
  'get_index_data': '/index.php/admin/datatongji/index',
  //首页数据
  'get_device_info': '/index.php/admin/device/get_device_info',
  //获取设备信息
  'dsgetconfigbyuser': '/index.php/admin/device/dsgetconfigbyuser',
  //获取设备信息
  'iotconfigset': '/index.php/admin/device/iotconfigset',
  //设置设备信息
  'iotdatalastget': '/index.php/admin/device/iotdatalastget',
  //拉取一级，二级数据
  'web_issue_order': '/index.php/admin/device/web_issue_order',
  //下发命令
  'get_firmware_info': '/index.php/admin/device/get_firmware_info',
  //监测新固件
  'upup_firmware': '/index.php/admin/device/upup_firmware',
  //下发升级固件命令
  'quxiao_fenpei': '/index.php/admin/device/quxiao_fenpei',
  'get_downloadtoken': '/index.php/admin/dict/get_downloadtoken',
  'daoru': '/index.php/admin/dict/daoru',
  'daochu': '/index.php/admin/dict/daochu',
  'config_caiyang_pinglv': '/index.php/admin/device/config_caiyang_pinglv',
  'config_nibianqi': '/index.php/admin/device/config_nibianqi',
  'trajectory_did_list': '/index.php/admin/device/trajectory_did_list',
  'get_now_lnglat': '/index.php/admin/device/get_now_lnglat',
  'trajectory_did_detail': '/index.php/admin/device/trajectory_did_detail',
  'get_rl_trends': '/index.php/admin/device/get_rl_trends',
  'get_yx_trends': '/index.php/admin/device/get_yx_trends',
  //协议列表
  'protocol_add': '/index.php/admin/protocol/protocol_add',
  'protocol_list': '/index.php/admin/protocol/protocol_list',
  'protocol_del': '/index.php/admin/protocol/protocol_del',
  'product_add': '/index.php/admin/product/product_add',
  'product_list': '/index.php/admin/product/product_list',
  'product_del': '/index.php/admin/product/product_del',
  //硬件版本号
  'hardware_ver_add': '/index.php/admin/product/hardware_ver_add',
  'hardware_ver_list': '/index.php/admin/product/hardware_ver_list',
  'hardware_ver_update': '/index.php/admin/product/hardware_ver_update',
  'hardware_ver_del': '/index.php/admin/product/hardware_ver_del',
  //硬件版本号
  'addfirmware': '/index.php/admin/firmwareversion/addfirmware',
  'getfirmwarelist': '/index.php/admin/firmwareversion/getfirmwarelist',
  'firmware_update': '/index.php/admin/firmwareversion/firmware_update',
  'deletefirmware': '/index.php/admin/firmwareversion/deletefirmware',
  //上传固件
  'uploadfirmwarever': "/index.php/admin/firmwareversion/uploadfirmwarever",
  //升级规则
  'addfirmware_rule': "/index.php/admin/firmwareversion/addfirmware_rule",
  'getfirmware_rulelist': "/index.php/admin/firmwareversion/getfirmware_rulelist",
  'firmware_ruleupdate': "/index.php/admin/firmwareversion/firmware_ruleupdate",
  'deletefirmware_rule': "/index.php/admin/firmwareversion/deletefirmware_rule",
  //上传设备ID文件
  'upload_dids': "/index.php/admin/firmwareversion/upload_dids",
  'download_file': "/index.php/admin/firmwareversion/download_file",
  //固件升级进度
  'progress_firmware': "/index.php/admin/device/progress_firmware",
  //关于设备下拉
  'device_about': '/index.php/admin/devicedetail/device_about',
  'export_success_did': '/index.php/admin/devicedetail/export_success_did',
  //密码管理
  'config_pass': '/index.php/admin/product/config_pass',
  'did_config_pass': '/index.php/admin/product/did_config_pass',
  //加热膜
  'set_jrm': '/index.php/admin/device/set_jrm',
  'dptimetaskadd': '/index.php/admin/device/dptimetaskadd',
  'dptimetasklist': '/index.php/admin/device/dptimetasklist',
  'dptimetaskdel': '/index.php/admin/device/dptimetaskdel',
  'dptimetaskedit': '/index.php/admin/device/dptimetaskedit',
  //设置时区
  'set_timezone': '/index.php/admin/admin/set_timezone'
};
export var chuku = {
  list_data: '/index.php/admin/download/download_list',
  //列表
  add_list_data: '/index.php/admin/download/download_add',
  //新增
  del_list_data: '/index.php/admin/download/download_del',
  //删除
  download_life: '/index.php/admin/download/download_file',
  //下载
  get_token: '/index.php/admin/device/getdownloadtoken',
  //获取token
  edit_platform: '/index.php/admin/admin/site_config',
  //修改平台
  get_effective_router: '/index.php/admin/devicedetail/trip_date_log',
  //获取有效时间
  get_effective_router_data: '/index.php/admin/device/trajectory_did_detail',
  //获取有效时间表格数据
  get_qr_code: '/index.php/admin/devicedetail/create_qrcode',
  //生成配网二维码
  get_website_data: '/index.php/admin/admin/get_site_info',
  download_data: '/index.php/admin/devicedetail/download_list',
  //下载记录
  del_download: '/index.php/admin/devicedetail/download_del',
  //删除下载
  get_device4g: '/index.php/admin/device4g/get_4g_chans',
  //获取4g
  get_left_data4g: '/index.php/admin/device4g/get_4g_data',
  //获取左侧数据
  get_4g_broken_line: '/index.php/admin/device4g/get_4g_broken_line',
  //获取右侧折线图
  get_danti_view: '/index.php/admin/device4g/get_danti_view',
  //获取右侧下角
  sn_file_log: '/index.php/admin/product/sn_file_log',
  //生产管理列表
  get_project_listinfo: '/index.php/admin/product/get_project_listinfo',
  //生产管理项目号下拉列表
  get_import_sn_did: '/index.php/admin/product/get_import_sn_did',
  //生产管理预览
  import_sn: '/index.php/admin/product/import_sn',
  //生产管理关联SN
  get_info_data: '/device/devicepwdlistpt',
  //获取消息列表
  edit_info_data: '/device/devicepwdreviewpt',
  //编辑消息列表
  get_qgl_data: '/index.php/admin/deviceqgl/get_qgl_data',
  //获取SCLI左侧数据
  get_qgl_broken_line: '/index.php/admin/deviceqgl/get_qgl_broken_line',
  //获取SCLI历史数据
  pl_list: '/index.php/admin/batchparams/did_params' //批量设置列表

};